
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50.799","height":"22.205"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_43543","data-name":"Group 43543"}},[_c('g',{attrs:{"id":"Group_43544","data-name":"Group 43544"}},[_c('path',{attrs:{"id":"Path_29916","data-name":"Path 29916","d":"M7.857 170.715l.008 3.829-4.065-.116.347-5.158-.778-.035a6.131 6.131 0 002.766 11.6h.524a6.131 6.131 0 006.13-6.131v-4.817a6.882 6.882 0 01-2.965.47z","transform":"translate(0 -158.632)","fill":"#1ccdfd"}}),_c('path',{attrs:{"id":"Path_29917","data-name":"Path 29917","d":"M66.5 6.131A6.131 6.131 0 0060.371 0h-.524a6.131 6.131 0 00-6.13 6.131V10.6c.311.712.311.712 1.306.712l3.664-.248.957-.008 1.263.044 2.23.5A6.13 6.13 0 0066.5 6.131","transform":"translate(-50.352)","fill":"#c458fb"}}),_c('path',{attrs:{"id":"Path_29918","data-name":"Path 29918","d":"M58.459 96.664v3.888h-1.977a6.1 6.1 0 00-2.766.659v5.547h4.678v-3.888h1.976a6.105 6.105 0 002.766-.659v-5.547z","transform":"translate(-50.351 -90.608)","fill":"#854cf9"}}),_c('path',{attrs:{"id":"Path_29919","data-name":"Path 29919","d":"M348.12 75.56h-5.269v12.722l2.7-.011v-3.234h2.572a4.739 4.739 0 000-9.477m1.309 6.392a2.331 2.331 0 01-1.653.685h-2.227v-4.676h2.226a2.338 2.338 0 011.653 3.991","transform":"translate(-321.371 -70.826)","fill":"#1a1a1a"}}),_c('path',{attrs:{"id":"Path_29920","data-name":"Path 29920","d":"M641.217 75.3h3.062l2.413 5.9 2.239-5.905h2.913l-5.218 12.736h-2.838l1.477-3.418a.4.4 0 000-.33z","transform":"translate(-601.045 -70.583)","fill":"#1a1a1a"}}),_c('path',{attrs:{"id":"Path_29921","data-name":"Path 29921","d":"M536.832 85.88v2.42h-7.9V75.611h2.7V85.88z","transform":"translate(-495.797 -70.874)","fill":"#1a1a1a"}})])])])
          )
        }
      }
    